import * as PropTypes from 'prop-types';
import React from 'react';
import the from '../objects/the';

const HorizontalBar = props => {
   return <>
      <div style={{
         backgroundColor: props.color,
         height: props.height,
      }}></div>
   </>;
};

HorizontalBar.propTypes = {
   color: PropTypes.string,
   height: PropTypes.number,
};
HorizontalBar.defaultProps = {
   color: the.color.forestGreen,
   height: 5,
};

export default HorizontalBar;